import AnalyzeService from '../../services/analyze';

const analyzeService = new AnalyzeService();

// actions globais
const CLEAR_ANNOTATIONS_ERRORS = 'CLEAR_ANNOTATIONS_ERRORS';
const FETCH_ANNOTATIONS = 'FETCH_ANNOTATIONS';
const SAVE_ANNOTATIONS = 'SAVE_ANNOTATIONS';

const annotationStrategyMap = {
  simpleCross: 'CRUZAMENTO_SIMPLES',
  simpleResults: 'GERAIS',
  multipleCross: 'CRUZAMENTO_MULTIPLO',
  evolutive: 'EVOLUTIVO',
  evolutiveCross: 'EVOLUTIVO_CRUZAMENTO_SIMPLES',
  correlation: 'CORRELACAO',
  correlationAuto: 'CORRELACAO_AUTOMATICA',
};

/**
 * Centralizador para disparo de actions de anotacao
 * para todos os resultados
 */

function fetchAnnotations(resultType, customerId, surveyId, resultIdentifier, dispatch) {
  const promise = analyzeService.fetchAnnotations(customerId, surveyId, resultIdentifier, resultType);
  dispatch({ type: FETCH_ANNOTATIONS, payload: promise, meta: { surveyId, customerId, resultIdentifier, resultType, operation: 'fetch' }});
}

function saveAnnotations(resultType, customerId, surveyId, resultIdentifier, annotation, dispatch) {
  const promise = analyzeService.saveAnnotations(customerId, surveyId, resultIdentifier, annotation, resultType);
  dispatch({ type: SAVE_ANNOTATIONS, payload: promise, meta: { surveyId, customerId, resultIdentifier, resultType, operation: 'save' }});
}

function clearAnnotationsError(resultType, customerId, surveyId, resultIdentifier, dispatch) {
  dispatch({ type: CLEAR_ANNOTATIONS_ERRORS, meta: { surveyId, customerId, resultIdentifier, resultType, operation: 'clear' }});
}

export { CLEAR_ANNOTATIONS_ERRORS, FETCH_ANNOTATIONS, SAVE_ANNOTATIONS, fetchAnnotations, saveAnnotations, clearAnnotationsError, annotationStrategyMap };
